export const API_URL = "https://candidate.neversitup.com/todo";
